__turbopack_context__.v({
  "desktopTable": "PhotonComparison-module__wDua7G__desktopTable",
  "glyph": "PhotonComparison-module__wDua7G__glyph",
  "head": "PhotonComparison-module__wDua7G__head",
  "headerCell": "PhotonComparison-module__wDua7G__headerCell",
  "heading": "PhotonComparison-module__wDua7G__heading",
  "inner": "PhotonComparison-module__wDua7G__inner",
  "mobileStickyHeader": "PhotonComparison-module__wDua7G__mobileStickyHeader",
  "mobileTable": "PhotonComparison-module__wDua7G__mobileTable",
  "section": "PhotonComparison-module__wDua7G__section",
  "stickyHeader": "PhotonComparison-module__wDua7G__stickyHeader",
  "subhead": "PhotonComparison-module__wDua7G__subhead",
});
